import { render, staticRenderFns } from "./MoleculeBuildingFloorLabel.vue?vue&type=template&id=238f5f40&scoped=true&"
import script from "./MoleculeBuildingFloorLabel.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingFloorLabel.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingFloorLabel.vue?vue&type=style&index=0&id=238f5f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f5f40",
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingFloorLabel.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeBuildingFloorLabel.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAtomLoader: require('/app/components/atoms/AtomLoader.vue').default,MoleculesProjectBuildingMoleculeAvailabilitySpaceFilterResultBuilding: require('/app/components/molecules/project/building/MoleculeAvailabilitySpaceFilterResultBuilding.vue').default})
